import { CURRENCY_CONFIGS } from "@constants";
import { Currency } from "@types";
import { BigNumber } from "bignumber.js";
import { fNumber } from "kz-ui-sdk";
import { getMemberSettings } from "./member-settings";

export const formatCurrency = (amount: number | BigNumber | string, currency: Currency, decimals = 2) => {
  const formattedAmount = fNumber(amount, {
    decimals,
  });
  return CURRENCY_CONFIGS[currency].pattern.replace("{{amount}}", formattedAmount).replace("{{currency}}", currency);
};

export const addCurrencySymbol = (text: string, currencySymbol?: string, currency?: Currency) => {
  if (!currency) {
    currency = getMemberSettings().currency as Currency;
  }
  const config = CURRENCY_CONFIGS[currency];
  const pattern = config.pattern;
  const symbol = currencySymbol || config.symbol;
  return pattern.replace("{{amount}}", text).replace("{{currency}}", symbol);
};
